import { render, staticRenderFns } from "./ClientContextBanner.vue?vue&type=template&id=7b72becc&scoped=true"
import script from "./ClientContextBanner.vue?vue&type=script&lang=js"
export * from "./ClientContextBanner.vue?vue&type=script&lang=js"
import style0 from "./ClientContextBanner.vue?vue&type=style&index=0&id=7b72becc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b72becc",
  null
  
)

export default component.exports